/**
 * 配置编译环境和线上环境之间的切换
 *
 * urlWebHttp: 域名地址
 *
 */
const timeout = 60000;
const ak = 'YEC9IHhGrw5361ioh6ugEsIqKIkPIwy7';
const filename = '/o2omallwx';

let urlWebHttp, appId, corpid, formLink, registerId;

switch (process.env.srconfig) {
    case 'dev':
        formLink = 'https://devtestscrm.zhiscity.com/scrm/#/form/collect';
        urlWebHttp = "";
        appId = "wx64f893655ac0e573"; // 众志成晟
        corpid = 'wwa1fe31bb8f35421f';
        registerId = 'wx64f893655ac0e573'; // 众志成晟
        break;
    case 'beta':
        formLink = 'https://devtestscrm.zhiscity.com/scrm/#/form/collect';
        urlWebHttp = "";
        appId = "wx64f893655ac0e573"; //众志成晟
        corpid = 'wweaa5fa552ee3e55a';
        registerId = 'wx64f893655ac0e573'; // 众志成晟
        break;
    case 'pro':
        formLink = 'https://tiyuxiong.cn/scrm/#/form/collect';
        urlWebHttp = "";
        appId = "wxfbbb1e33db1585a7"; //熊启科技公众号
        corpid = 'wweaa5fa552ee3e55a';
        registerId = 'wxfbbb1e33db1585a7'; // 熊启科技公众号
        break;
    case 'testdev':
        formLink = 'https://devtestscrm.zhiscity.com/scrm/#/form/collect';
        urlWebHttp = "";
        appId = "wx64f893655ac0e573"; //众志成晟
        corpid = 'wwa1fe31bb8f35421f';
        registerId = 'wx64f893655ac0e573'; // 众志成晟
        break;
    default://默认开发
        formLink = 'https://devtestscrm.zhiscity.com/scrm/#/form/collect';
        urlWebHttp = "";
        appId = "wx64f893655ac0e573"; //众志成晟
        corpid = 'wweaa5fa552ee3e55a';
        registerId = 'wx64f893655ac0e573'; // 众志成晟
        break;
}
export default {
    formLink,
    urlWebHttp,
    appId,
    timeout,
    ak,
    filename,
    corpid,
    registerId
}



// WEBPACK FOOTER //
// ./src/config.js